import React from "react";

export const TabContext = React.createContext();
export const TabProvider = TabContext.Provider;

export const TabGroupContext = React.createContext();
export const TabGroupProvider = TabGroupContext.Provider;
